import { Download, RefreshCcw } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  DepotGridPanel,
  depotTableClassName,
  depotTableHeadClassName,
  depotTdClassName,
  depotThClassName,
} from './depot-grid';

const reportRows = [
  { report: 'Container Position', scope: 'By account, line, depot, status', cadence: 'Live / Daily', owner: 'Ops', output: 'Grid, CSV, PDF' },
  { report: 'Gate Movement', scope: 'Gate in/out, appointment, truck, driver', cadence: 'Live / Shift', owner: 'Gate', output: 'Grid, CSV' },
  { report: 'Repair Approval', scope: 'Estimate, approval, damage hold, ageing', cadence: 'Live / Daily', owner: 'M&R', output: 'Grid, PDF' },
  { report: 'Storage & Activity Billing', scope: 'Cost source, price source, invoice line', cadence: 'Batch', owner: 'Finance', output: 'Grid, CSV, SOA' },
  { report: 'Customer SOA Pack', scope: 'Invoices, credit notes, payment notices, disputes', cadence: 'Monthly / On demand', owner: 'Finance', output: 'PDF, WhatsApp link' },
];

export default function DepotReportsPage() {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold">Reports</h2>
          <p className="text-sm text-muted-foreground">
            One report menu. Use tabs and filters inside the report, not many sidebar items.
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm"><RefreshCcw className="mr-2 h-4 w-4" />Refresh</Button>
          <Button size="sm"><Download className="mr-2 h-4 w-4" />Export Batch</Button>
        </div>
      </div>

      <DepotGridPanel title="Essential Depot Reports" subtitle="Reports are generated from the same lifecycle, activity costing, and billing source rows.">
        <table className={depotTableClassName}>
          <thead className={depotTableHeadClassName}>
            <tr>
              <th className={depotThClassName}>Report</th>
              <th className={depotThClassName}>Scope</th>
              <th className={depotThClassName}>Cadence</th>
              <th className={depotThClassName}>Owner</th>
              <th className={depotThClassName}>Output</th>
              <th className={depotThClassName}>Status</th>
            </tr>
          </thead>
          <tbody>
            {reportRows.map((row) => (
              <tr key={row.report} className="border-b last:border-0 hover:bg-muted/20">
                <td className={`${depotTdClassName} font-medium`}>{row.report}</td>
                <td className={depotTdClassName}>{row.scope}</td>
                <td className={depotTdClassName}>{row.cadence}</td>
                <td className={depotTdClassName}>{row.owner}</td>
                <td className={depotTdClassName}>{row.output}</td>
                <td className={depotTdClassName}><Badge variant="outline">Ready</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </DepotGridPanel>
    </div>
  );
}
